import { axiosFactory } from './axiosFactory'

export const axiosCustomerV3 = axiosFactory.getAxios('customerV3')
